<template>
	<v-container fluid constrain grid-list-xl>
		<!-- Erik 10.12.2019:  PAGE FOR TESTING -->
		<PrintGiftCardDialog v-model="show"></PrintGiftCardDialog>
		<v-btn color="primary" @click="show = true">Vis popup</v-btn>
	</v-container>
</template>

<script>
import PrintGiftCardDialog from './PrintGiftcardDialog';
export default {
	components: {
		PrintGiftCardDialog
	},
	data() {
		return {
			show: false
		};
	}
};
</script>

<style></style>
